import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function GuestTableSkeleton({ showColumn = false }: { showColumn?: boolean }) {
  return (
    <div className="flex flex-col overflow-hidden rounded-md border border-border">
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-3" />
        <Skeleton className="h-3 w-28" />
        {showColumn && <Skeleton className="h-3 w-20" />}
        <Skeleton className="ml-auto h-3 w-32" />
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-14" />
      </div>
      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[46px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="size-4 flex-none rounded" />
          <Skeleton className="h-3 w-28" />
          {showColumn && <Skeleton className="h-3 w-20" />}
          <Skeleton className="ml-auto h-3 w-32" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="size-4 flex-none rounded" />
        </div>
      ))}
    </div>
  );
}
